export const reviews = [
  {
    name: 'Rakesh Sharma',
    date: '10 February 2024',
    reviewText:
      'We ordered bulk Amazon gift cards for our corporate rewards program, and the process was seamless. Quick delivery and excellent customer support!',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Anjali Mehta',
    date: '08 February 2024',
    reviewText:
      'I purchased 50+ Myntra gift cards for employee appreciation. 99gift made the process easy with instant digital delivery. Highly recommended!',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Amit Verma',
    date: '05 February 2024',
    reviewText:
      'Our company placed a bulk order for Starbucks gift cards as Diwali gifts. The transaction was smooth, and our employees loved them!',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Neha Tiwari',
    date: '02 February 2024',
    reviewText:
      'Great experience with 99gift! We bought Nykaa and Ajio gift cards in bulk for a client event. Everything was delivered on time!',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Sandeep Malhotra',
    date: '28 January 2024',
    reviewText:
      'We needed 100+ Zomato gift cards for a corporate giveaway, and 99gift delivered them instantly. Hassle-free and efficient service!',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Pooja Saxena',
    date: '25 January 2024',
    reviewText:
      'Ordered bulk Lifestyle and Pantaloons gift cards for our festival gifting program. The entire process was smooth, and the team was very responsive!',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Arjun Iyer',
    date: '22 January 2024',
    reviewText:
      'Our HR team bought Google Play gift cards in bulk for employee incentives. Quick delivery and best pricing—99gift is the perfect gifting partner!',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Priya Sharma',
    date: '18 January 2024',
    reviewText:
      'I ordered an Amazon gift card from 99gift, and it was delivered instantly! Super convenient and perfect for last-minute gifting. Highly recommend!',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Rahul Verma',
    date: '15 January 2024',
    reviewText:
      'Amazing experience! Bought a Steam gift card for my brother, and he received it within minutes. Hassle-free and reliable service!',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Neha Gupta',
    date: '12 January 2024',
    reviewText:
      '99gift is my go-to for digital gift cards! I got a Nykaa gift card for my best friend’s birthday, and she loved it. Super smooth transaction!',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Ankit Mehra',
    date: '09 January 2024',
    reviewText:
      "I was looking for a perfect Valentine's gift and found a Lifestyle gift card here. My girlfriend loved it! Easy purchase and instant delivery!",
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Swati Rao',
    date: '06 January 2024',
    reviewText:
      'Excellent service! I got a Starbucks gift card for my friend, and she was thrilled. Will definitely buy again from 99gift!',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Kunal Bhatia',
    date: '03 January 2024',
    reviewText:
      'Fast and secure! Bought a Google Play gift card for myself, and the process was seamless. 99gift is truly reliable!',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Ritu Singh',
    date: '30 December 2023',
    reviewText:
      'Valentine’s Day made easy! Ordered a Myntra gift card for my husband, and he picked his own gift. Best gifting platform!',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Vishal Kapoor',
    date: '27 December 2023',
    reviewText:
      'Needed a last-minute gift for my sister’s birthday and got her an Ajio gift card. Instant email delivery saved the day. Thank you, 99gift!',
    helpfulCount: 1,
    rating: 5,
  },
];

export const cinepolisReviews = [
  {
    name: 'Kunal Bhatia',
    date: '03 January 2025',
    reviewText:
      'Fast and secure! Bought a Cinepolis card for myself, and the process was seamless. 99gift is truly reliable!',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Priya Mehra',
    date: '12 February 2025',
    reviewText:
      'Loved the quick delivery. Cinepolis e-Gift Card arrived instantly on WhatsApp. Great experience and perfect for last-minute gifting ideas!',
    helpfulCount: 3,
    rating: 5,
  },
  {
    name: 'Rohit Sharma',
    date: '25 March 2025',
    reviewText:
      'Excellent service! Ordered a Cinepolis gift card for a friend’s birthday and received it instantly. Highly recommended platform for gifting.',
    helpfulCount: 2,
    rating: 5,
  },
  {
    name: 'Sneha Kapoor',
    date: '10 April 2025',
    reviewText:
      'Very smooth checkout process. Bought Cinepolis e-Gift Card easily and used it for tickets plus snacks. 99gift made it super simple.',
    helpfulCount: 1,
    rating: 4,
  },
  {
    name: 'Amit Verma',
    date: '06 May 2025',
    reviewText:
      'Secure payment and instant email delivery. Purchased Cinepolis voucher for my parents and they loved the experience. Great gifting option online!',
    helpfulCount: 4,
    rating: 5,
  },
  {
    name: 'Neha Gupta',
    date: '14 June 2025',
    reviewText:
      'Hassle-free and fast! Cinepolis card was delivered in seconds. Used it for recliner seats and popcorn. Totally satisfied with 99gift service.',
    helpfulCount: 2,
    rating: 5,
  },
  {
    name: 'Arjun Malhotra',
    date: '02 July 2025',
    reviewText:
      'The Cinepolis gift card made my anniversary gift simple yet special. Instant delivery and smooth redemption. Reliable and trustworthy website!',
    helpfulCount: 3,
    rating: 5,
  },
  {
    name: 'Simran Kaur',
    date: '19 August 2025',
    reviewText:
      'Bought Cinepolis e-Gift Card during a festival sale. The delivery was quick, card worked perfectly. Great option for festive gifting needs!',
    helpfulCount: 2,
    rating: 4,
  },
  {
    name: 'Vikas Jain',
    date: '07 September 2025',
    reviewText:
      'Absolutely loved the service! Cinepolis voucher arrived instantly and was super easy to redeem. Will definitely shop again from 99gift.in.',
    helpfulCount: 5,
    rating: 5,
  },
  {
    name: 'Ritu Sharma',
    date: '28 October 2024',
    reviewText:
      'Perfect gifting solution! Sent a Cinepolis e-Gift Card to my cousin. She received it instantly and booked her favourite movie immediately.',
    helpfulCount: 1,
    rating: 5,
  },
];

export const PVRReviews = [
  {
    name: 'Rahul Khanna',
    date: '05 January 2025',
    reviewText:
      'Super smooth process! Bought a PVR gift card and it was delivered instantly. Booking tickets and snacks became so convenient.',
    helpfulCount: 2,
    rating: 5,
  },
  {
    name: 'Meera Joshi',
    date: '20 January 2025',
    reviewText:
      'Amazing gifting option! Sent a PVR e-Gift Card to my sister and she loved it. Very easy to buy and redeem.',
    helpfulCount: 3,
    rating: 5,
  },
  {
    name: 'Ankit Sharma',
    date: '03 February 2025',
    reviewText:
      'Quick delivery and secure payment. Bought PVR voucher for my parents, and they enjoyed a weekend movie with popcorn. Totally worth it.',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Sonal Kapoor',
    date: '16 March 2025',
    reviewText:
      'Best gifting solution! PVR gift card was delivered instantly on email. Used it for recliner seats and snacks. Very happy with service.',
    helpfulCount: 4,
    rating: 5,
  },
  {
    name: 'Deepak Verma',
    date: '09 March 2025',
    reviewText:
      'The PVR gift card worked perfectly! Super fast purchase, and my kids loved using it for their favourite superhero movie. Great experience.',
    helpfulCount: 2,
    rating: 4,
  },
  {
    name: 'Shreya Malhotra',
    date: '21 April 2025',
    reviewText:
      'Bought a PVR e-Gift Card from 99gift. Smooth checkout, quick delivery, and very easy redemption at the theatre. Highly recommended option.',
    helpfulCount: 3,
    rating: 5,
  },
  {
    name: 'Aditya Mehta',
    date: '08 May 2025',
    reviewText:
      'Really impressed with the speed. Ordered a PVR voucher as a birthday gift and it was delivered instantly. Perfect for last-minute gifting.',
    helpfulCount: 1,
    rating: 5,
  },
  {
    name: 'Pooja Sinha',
    date: '24 June 2025',
    reviewText:
      'Loved how convenient this is! Bought a PVR gift card and redeemed it without any hassle. Will definitely buy again from 99gift.',
    helpfulCount: 2,
    rating: 5,
  },
  {
    name: 'Nikhil Arora',
    date: '11 June 2025',
    reviewText:
      'Simple, fast, and reliable! Purchased a PVR e-Gift Card and shared it with a friend. Instant delivery made the surprise more special.',
    helpfulCount: 5,
    rating: 5,
  },
  {
    name: 'Kriti Singh',
    date: '30 July 2025',
    reviewText:
      'Great product! Sent a PVR gift card to my colleague for her promotion. She used it easily and really appreciated the gesture.',
    helpfulCount: 2,
    rating: 5,
  },
];
